import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

export const getSectionsByPageId = async (pageId) => {
  const response = await axiosClient.get(`/api/admin/pages/${pageId}/sections`);
  return unwrapApiResponse(response);
};
